import Vue from "vue";
import RepositoryResponse from "@/interfaces/Repository/RepositoryResponse";
import { AxiosRequestConfig } from "axios";
import qs from "qs";

/**
 * @deprecated Use RepositoryRequest instead.
 */
export async function getRepositoryResponse(
  endPoint: string,
  // eslint-disable-next-line  @typescript-eslint/no-explicit-any
  getRequestParameters?: any
): Promise<RepositoryResponse> {
  let repositoryResponse = {} as RepositoryResponse;

  const requestConfig: AxiosRequestConfig = {
    paramsSerializer: (parametersObject) =>
      qs.stringify(parametersObject, { arrayFormat: "repeat" }),
    params: getRequestParameters,
  };

  await Vue.axios.get(endPoint, requestConfig).then((response) => {
    let recordCount = response.data.length;
    if (response.headers["total-number-records-non-paged"]) {
      recordCount = parseInt(
        response.headers["total-number-records-non-paged"]
      );
    }

    repositoryResponse = {
      data: response.data,
      status: response.status,
      totalNumberRecordsNonPaged: recordCount,
    } as RepositoryResponse;
  });

  return repositoryResponse;
}

/**
 * @deprecated Use RepositoryRequest instead.
 */
export async function putRepositoryResponse(
  endPoint: string,
  // eslint-disable-next-line  @typescript-eslint/no-explicit-any
  data?: any
): Promise<RepositoryResponse> {
  let repositoryResponse = {} as RepositoryResponse;

  await Vue.axios.put(endPoint, data).then((response) => {
    let recordCount = response.data.length;
    if (response.headers["total-number-records-non-paged"]) {
      recordCount = parseInt(
        response.headers["total-number-records-non-paged"]
      );
    }

    repositoryResponse = {
      data: response.data,
      status: response.status,
      totalNumberRecordsNonPaged: recordCount,
    } as RepositoryResponse;
  });

  return repositoryResponse;
}

/**
 * @deprecated Use RepositoryRequest instead.
 */
export async function postRepositoryResponse(
  endPoint: string,
  // eslint-disable-next-line  @typescript-eslint/no-explicit-any
  data?: any
): Promise<RepositoryResponse> {
  let repositoryResponse = {} as RepositoryResponse;

  await Vue.axios.post(endPoint, data).then((response) => {
    let recordCount = response.data.length;
    if (response.headers["total-number-records-non-paged"]) {
      recordCount = parseInt(
        response.headers["total-number-records-non-paged"]
      );
    }

    repositoryResponse = {
      data: response.data,
      status: response.status,
      totalNumberRecordsNonPaged: recordCount,
    } as RepositoryResponse;
  });

  return repositoryResponse;
}
